import React, { useState, useEffect } from 'react';
import { ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, Button, Input, Select, Checkbox, message, Spin, Upload, Space } from 'antd';
import moment from 'moment';
import { DatePicker, CKEditor } from 'components/atoms';
import { fetcher } from 'services';
import { useMailTemplateCode } from 'hooks'
import { MSG } from 'commons/constants';
import { UploadFile } from 'antd/lib/upload/interface';
import { UploadOutlined,CloseOutlined, PaperClipOutlined, DownloadOutlined, SearchOutlined } from '@ant-design/icons';
import { isFileViewer } from 'utils/file-utils';
import { FileViewerModal} from 'components/molecules';
import { endpoints } from 'services';
import { SERVER_URL } from 'commons/constants';
import axios from 'axios';
import { usePopupManager } from 'react-popup-manager';

export interface MailSendFormProps extends PopupProps {
    id: number;
    mail_group: string;
    mail_type: string;
    is_mail_form?: boolean;
    supply_period?: string;
    onCancel?: () => void;
    onConfirm?: () => void;
}

export interface FileInfoType {
    fileid: number, 
    filename: string    
}

const MailSendForm = ({ id, mail_group, mail_type, is_mail_form = true, supply_period, onCancel, onConfirm }: MailSendFormProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
  const [isSendDate, setIsSendDate] = useState<boolean>(false);
  const [isNew, setIsNew] = useState<boolean>(false);
  const [mailBody, setMailBody] = useState<string>('');  
  const [isLoding, setIsLoading] = useState<boolean>(false);  
  const [mailFileList, setMailFileList] = useState<UploadFile[]>([]); 
  const [mailFile, setMailFile] = useState<FileInfoType>({fileid: 0, filename: ''});   
  const [mailContent, setMailContent] = useState<StudentMailContentDto>({
      id: 0,
      app_srl: 0,
      mail_group: mail_group,
      student_id: 0,
      mail_id: 0,
      mail_type: '',
      subject: '',
      mail_body: '',
      mail_to: '',
      mail_cc: '',
      send_date: '',
      send_date_yn: 'N',
      status: '10',
      file_id: 0,
      file_name: '',
  });
    
  const { open } = usePopupManager(); 

  /* ======================================================
  * hooks
  * ====================================================== */
    const { codeList } = useMailTemplateCode({params: {group: mail_group, mail_type: mail_type} })

   /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();

   /* ======================================================
   * events
   * ====================================================== */
    const onNew = () => {
        setIsNew(!isNew);
    }

    const onSubmit = (e) => {
        setIsLoading(true);
        fetcher.b2c.postStudentMailSend ({
            id: mailContent.id,
            mail_group: mail_group,
            app_srl: mailContent.app_srl,
            student_id: mailContent.student_id,
            mail_id: e.mail_id,
            mail_type: mail_type,
            subject: e.subject,
            mail_body: mailBody,
            mail_to: e.mail_to,
            mail_cc: e.mail_cc,
            send_date: moment(e.send_date).format('YYYY-MM-DD HH:mm'),
            send_date_yn: isSendDate?'Y':'N',
            status: isSendDate?'30':'20',
            fileData: mailFileList.map((file) => file.originFileObj),
            file_id: mailFile.fileid,            
        })
        .then((res) => {
            setIsLoading(false);            
            switch (res.code) {
                case 200:
                    message.info(MSG.SUCCESS_MAIL_SEND, 1);
                    onConfirm?.();
                break;
                default:  
                break;
            };
        }); 
        
    };
    
    const onSaveMail = () => {
        fetcher.b2c.postStudentMailSend ({
            id: mailContent.id,
            mail_group: mail_group,
            app_srl: mailContent.app_srl,
            student_id: mailContent.student_id,
            mail_id: form.getFieldValue("mail_id"),
            mail_type: mail_type,
            subject: form.getFieldValue("subject"),
            mail_body: mailBody,
            mail_to: form.getFieldValue("mail_to"),
            mail_cc: form.getFieldValue("mail_cc"),
            send_date: moment(form.getFieldValue("send_date")).format('YYYY-MM-DD HH:mm'),
            send_date_yn: isSendDate?'Y':'N',
            status: '10',//mailContent.status === '30'?'30':'10',
            fileData: mailFileList.map((file) => file.originFileObj),
            file_id: mailFile.fileid,                        
        })
        .then((res) => {
            switch (res.code) {
                case 200:
                    message.info(MSG.SUCCESS_SAVE, 1);
                    onConfirm?.();
                break;
                default:  
                break;
            };
        });  
    }
    const getMailContent = (id: number, mail_type: string, mail_id: number) => {
        setIsLoading(true);
        fetcher.b2c.postStudentMailContent ({
            id: id,
            mail_group: mail_group,
            mail_type: mail_type, 
            mail_id: mail_id,
            is_new: isNew?'Y':'N',
        })
        .then((res) => {
            setIsLoading(false);            
            switch (res.code) {
                case 200:
                    if (!!res.result) {
                        let m_body = res.result.info.mail_body;
                        if (supply_period) {
                            m_body = m_body.replaceAll('[$supply_period]', supply_period)
                        };

                        setMailContent({
                            ...res.result.info,
                            mail_body: m_body
                        });
                    }
                break;
                default:  
                break;
            };
        }); 
    }
    

    const onDownload = (fileSeq:number, fileName: string): void => {

        axios({
          url: SERVER_URL + endpoints.file.download + '?file_id=' + fileSeq,
          method: 'get',
          responseType: 'blob',
        })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
          })
          .catch(() => {
            message.error('파일 다운로드 중 에러가 발생했습니다.', 1);
          });
        };
    
        const onOpenFileViewer = (fileId: number, fileName: string) => {
          open(FileViewerModal, {
            fileid: fileId,
            filename: fileName,
            seq: 0,
            gubun: '',
            editable: false,
            onClose: (isOk) => {
              if (isOk) {
                
              };
            },
          }); 
         }        
    /* ======================================================
    * methods
    * ====================================================== */
 
       
  /* ======================================================
   * effects
   * ====================================================== */

    useEffect(() => {
        if ((!!id && !!mail_type) || !!supply_period) {
            getMailContent(id, mail_type, 0)
        }
    }, [id, mail_type, isNew]);

    useEffect(() => {
        if (!!supply_period) {
            getMailContent(id, mail_type, 0)
        }
    }, [supply_period]);

    useEffect(() => {
        if (!!mailContent) {
            form.setFieldsValue({
                mail_id: mailContent.mail_id,
                subject: mailContent.subject,
                mail_to: mailContent.mail_to,
                mail_cc: mailContent.mail_cc,
                mail_body: mailContent.mail_body,
                send_date_yn: mailContent.send_date_yn==='Y'?true:false,
                send_date: moment(mailContent.send_date),
            });
            setMailBody(mailContent.mail_body); 
            setIsSendDate(mailContent.send_date_yn==='Y'?true:false);
            if (!!mailContent.file_id && mailContent.file_name)
            setMailFile({fileid: mailContent.file_id, filename: mailContent.file_name});
        }
    }, [mailContent]);
    
    return (
        <div style={{width:'100%'}}>
            <Spin spinning={isLoding} tip="처리중입니다. 잠시만 기다려 주세요." size="large">
            <Form
                form={form}
                name="LecturerInfo"
                layout="horizontal"  
                labelCol={{ flex: '120px' }}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >   
            {(is_mail_form) && (
                <Form.Item name="mail_id" label={'유형'} rules={[{ required: true, message: '' }]}>
                    <Select 
                        options={codeList}
                        onSelect={(value)=>getMailContent(id, mail_type, value)}
                    />               
                </Form.Item> 
            )}
                <Form.Item name="subject" label={'제목'} rules={[{ required: true, message: '' }]}>
                    <Input type="text" placeholder='메일 제목을 입력하세요'/>                    
                </Form.Item>      
                <Form.Item name="mail_to" label={'받는사람'} rules={[{ required: true, message: '' }]}>
                    <Input type="text" placeholder='이메일을 입력하세요'/>                    
                </Form.Item>   
                <Form.Item name="mail_cc" label={'참조'}>
                    <Input type="text" placeholder='이메일을 입력하세요'/>                    
                </Form.Item> 
                <Form.Item name="file_id" label={'첨부파일'}>
                    <Space direction="vertical">
                        <Upload
                            fileList={mailFileList}
                            onChange={({ fileList: list }) => {
                                setMailFileList(list);
                            }} 
                            beforeUpload={(file, filelist) => {
                                if ((file.size as number) >= 10 * 1024 * 1024) {
                                  message.warn('파일 용량 초과', 1);
                                  return Upload.LIST_IGNORE;
                                }
                            }}                                                       
                            customRequest={() => true}
                            maxCount={1}
                            accept=".pdf,.jpg,.jpeg,.png"
                            showUploadList={false}
                            disabled={mailFile.fileid > 0}
                        >
                            <Button icon={<UploadOutlined />} style={{fontSize:'12px'}}>등록</Button>
                        </Upload>        
                        {(mailFile.fileid > 0) && (
                            <Space key={mailFile.fileid}>
                                <Button onClick={()=>{onDownload(mailFile.fileid, mailFile.filename)}} shape="round" icon={<DownloadOutlined />} size='small' style={{padding:'0px 3px'}}/>
                                {isFileViewer(mailFile.filename) && (<Button onClick={()=>{onOpenFileViewer(mailFile.fileid, mailFile.filename)}} shape="round" icon={<SearchOutlined />} size='small' style={{padding:'0px 3px'}}/>)}                                   

                                {mailFile.filename}
                                <CloseOutlined
                                    style={{ fontSize: 12, color: '#b9b9b9' }}
                                    onClick={() => {
                                        setMailFile({fileid:0, filename:''});
                                    }}
                                />
                            </Space>
                        )} 
                        {mailFileList?.map(({ uid, name }) => (
                            <Space key={uid}>
                            <PaperClipOutlined /><span style={{width: '200px'}}>{name}</span>
                            <CloseOutlined
                                style={{ fontSize: 12, color: '#b9b9b9' }}
                                onClick={() => {
                                    setMailFileList(mailFileList.map((file) => file).filter((file) => file.uid !== uid));
                                }}
                            />
                            </Space>
                        ))}                                               
                    </Space>                                        
                </Form.Item>                        
                <Form.Item name="mail_body" label={'내용'} rules={[{ required: true, message: '' }]}>
                    <CKEditor 
                        className='ck-reply-writer'
                        data={mailContent?mailContent.mail_body:''}
                        onSetData={setMailBody}
                    />  
                </Form.Item> 
                <Form.Item label={'예약발송'}>
                    <Form.Item 
                        name="send_date_yn" 
                        valuePropName="checked"
                        style={{ display: 'inline-block' }}                  
                    >   
                        <Checkbox onChange={(e)=>setIsSendDate(e.target.checked)}>예약발송확인</Checkbox>  
                    </Form.Item> 
                    <Form.Item 
                        style={{ display: 'inline-block' }}
                        name="send_date" 
                        rules={[{ required: isSendDate, message: '' }]}
                    >   
                        <DatePicker 
                            showTime={true}
                            format="YYYY-MM-DD HH:mm"
                            disabled={!isSendDate}
                            minuteStep={5} 
                        />  
                    </Form.Item>            
                </Form.Item>  
                <ButtonGroup className={'buttonsWrapper'}>
                    <div>
                        <Button onClick={onCancel} style={{marginRight: "5px"}}>취소</Button>
                        <Button onClick={onNew} style={{width: "80px"}}>{isNew?'이전메일':'신규메일'}</Button>
                    </div>
                    {(is_mail_form) ? (
                    <div>
                        <Button style={{marginRight: "5px"}} onClick={onSaveMail}>저장</Button>
                        <Button htmlType="submit"  type="primary" >발송</Button>
                    </div>
                    ) : (
                        <Button htmlType="submit"  type="primary" >확인</Button>
                    )}
                </ButtonGroup>
            </Form>
            </Spin>
        </div>
    )    
};

export default React.memo(MailSendForm);    